import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Card.Module.css';
import product1 from "../../assets/images/CORAZON-VERDE-TRANS.png"
// import product1 from '../../assets/PRODUCTO_SIN_FONDO.png';
import product2 from "../../assets/images/CORAZON-VERDE-TRANS-FONDO.png"
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated } from '../../utils/auth/auth';
import christmas from "../../assets/images/beautisale.jpg"
import gangas from "../../assets/images/gangas3.png"

import { Box, darken, Typography } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import Carousel from 'react-multi-carousel';

import { agregarAlCarrito } from '../../features-slice/cart/carritoSlice';
import ModalEditProduct from '../modals/modalEditProduct/ModalEditProduct';
import { currencyDisplay } from '../../utils/cart/cart';
import { isNewProduct } from '../../utils/products/products';
import vegan from '../../assets/Sellos/VEGAN.png';
import toast from 'react-hot-toast';
import axios from 'axios';


function Card({ sale, isMobile, termino, color, saleImage, marcaSection1, marcaSection2, marcaSection3 }) {

// console.log("saleImage",saleImage)

// console.log("marca1", marcaSection1)

// console.log("marca2", marcaSection2)

// console.log("marca3", marcaSection3)


		const navigate= useNavigate()
	const token = localStorage.getItem('Token');
	const config = {
		headers: {
			xtoken: `${token}`,
		},
	};
	const sinStock =
	(sale.variantes.length === 0 && (!sale.disponibles || sale.disponibles <= 0)) ||
	(sale.variantes.length > 0 && sale.variantes.every(v => !v.disponibles || v.disponibles <= 0));
  
	const dispatch = useDispatch();
	const [showModal, setShowModal] = React.useState(false);
	const user = useSelector((state) => state.user.userInfo);
	const isSuperAdmin = user.role === 'SUPERADMIN_ROLE';

	


	// const [saleImage, setSaleImage]=React.useState("")

	// React.useEffect(() => {
	// 	const cargarVideo = async () => {
	// 		const { data } = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=GANGA_SECTION`);
	// 		setSaleImage(data.imagenes[0]?.url);
	// 	};
	// 	cargarVideo();
	// 	window.addEventListener('actualizar-producto', cargarVideo);
	// }, []);
const urlCatalog  = `/producto/${sale._id}?termino=${termino}`

	// Como mostrar las imagenes con el paso del mouse por encima
	const img1 = sale.img ? sale.img : product1;
	const img2 = sale.img2 ? sale.img2 : product2;
	const [cambioImg, setCambioImg] = React.useState(false);
	const handleMouseEnter = () => {
		setCambioImg(true);
	};
	const handleMouseLeave = () => {
		setCambioImg(false);
	};
	const [showVariantSelector, setShowVariantSelector] = React.useState(false);
	const [selectedVarianteId, setSelectedVarianteId] = React.useState('');

	const isMobileScreen = useMediaQuery({ maxWidth: 768 }); // Cambio de imagen en pantallas pequeñas
	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 1,
			slidesToSlide: 1,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 1,
			slidesToSlide: 1,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
			slidesToSlide: 1,
		},
	};

	function manejadorAgregarACarrito() {
	// console.log("producto", sale)
	// console.log("variante", selectedVarianteId)
		if(sale.variantes?.length > 0 && !selectedVarianteId ){
			toast.error("Debes seleccionar una variante antes de agregar al carrito")
		}
		else if (selectedVarianteId) {
			const carritoItem = {
				...sale,
				cantidad: 1,
				varianteId: selectedVarianteId,
			};

			dispatch(agregarAlCarrito(carritoItem));
		} else {
			dispatch(agregarAlCarrito({ ...sale, cantidad: 1 }));
		}
	}

	const handleOpenModal = () => {
		setShowModal(true);
	};

	const handleCloseModal = () => {
		setShowModal(false);
		setSelectedVarianteId('');
	};
//console.log(sale)
	const handleSaveData = async (formData) => {
		try {
			await axios.put(
				`${process.env.REACT_APP_BACK_URL}/api/productos/${sale._id}`,
				formData,
				config
			);
			const event = new Event('actualizar-producto');
			window.dispatchEvent(event);

			toast.success('Producto actualizado con éxito');
		} catch (error) {
			toast.error('Error al actualizar producto');
		}
	};
	const [imageLoading, setImageLoading] = React.useState(true);
  
// Función para procesar la cadena
const procesarCadena = (cadena) => {
  if (cadena && cadena[0].match(/\d/)) {
    return cadena.slice(1);
  } else {
    return cadena;
  }
};
  

    const handleImageLoad = () => {
        setImageLoading(false);
    };

// console.log(sale)

	return (
		<div
		
			className={`card cardcitita ${cambioImg ? 'hovered' : ''}  containerImage ${
				isMobile ? 'mobile-card' : '' // Aplica la clase 'mobile-card' si isMobile es verdadero
			}`}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>

			{isSuperAdmin && sale?._id && (
				<div style={{position:"absolute", zIndex:10}}className='edit-icon-card' onClick={handleOpenModal}>
					<abbr title={`editar ${sale.nombre}`}>
						<i className='bi bi-pencil'></i>
					</abbr>
				</div>
			)}
				<div className='ofertas'>
					{saleImage !== ""  && 
					<img className='christmas' src={saleImage} alt='SaleLogo' />
					}
						{!saleImage && sale?.gangaSection && marcaSection1 && marcaSection1 !== ""  && 
					<img className='christmas' src={marcaSection1} alt='SaleLogo1' />
				
					}
									{!saleImage &&
						(sale?.imperdibleSection || sale?.tags2?.includes("2x1")) &&
						marcaSection2 &&
						marcaSection2 !== "" && (
							<img
								style={{ backgroundColor: "" }}
								className="christmas"
								src={marcaSection2}
								alt="SaleLogo2"
							/>
					)}
							{!saleImage && sale?.miniBeautiSection && marcaSection3 && marcaSection3 !== ""  && 
					<img className='christmas' src={marcaSection3} alt='SaleLogo3' />
				
					}
					{sale.fechaCreacion && !saleImage
						? isNewProduct(sale.fechaCreacion) && (
							<span className='badge bg-info text-white new-sale'>NEW</span>
						)
						: ''}

							{sinStock
						? (
							<span style={{backgroundColor:"#424242", marginTop:"5px", marginLeft:"5px"}} className='badge  text-white new-sale'>AGOTADO</span>
						)
						: ''}
					{sale.vegan && (
						<abbr title='Producto vegano'>
							<img className='vegan' src={vegan} alt='Vegano' />
							
						</abbr>
					)}
				</div>
							<Link className='btn btn-sm card linkDetail' to={`/producto/${sale._id}?termino=${termino}`} disabled>
						
							<img
						
								src={cambioImg ? img2 : img1}
								alt={`Imagen de `}
								className={`bd-placeholder-img card-img-top cardcita `}
							/>
						
					</Link>
				
					<div className='card-body contenedorPreciosBotones'>
						<Link className='btn btn-sm  linkDetail' to={`/producto/${sale._id}`} disabled>
							<abbr
								title={sale.descripcion}
								style={{
									display: 'inline-block',
									cursor: 'pointer',
									width: '2vw !important',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'wrap',
								}}
							>
								<Typography
	style={{
		fontFamily: "Poppins",
		fontSize: isMobile ? "12px" : "14px",
		color: "#5c5c5c",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		fontWeight:600
	}}
	title={sale?.nombre}
>
	{(() => {
		let nombre = sale?.nombre || '';
		if (/^\d/.test(nombre)) {
			nombre = nombre.slice(1); // quitamos el primer carácter si es un número
		}
		return nombre.length > 30 ? `${nombre.slice(0, 30)}...` : nombre;
	})()}
</Typography>


								<Typography style={{height:"25px",fontFamily:"Poppins",marginBottom:"5px", fontSize:isMobile?"10px":"10px", color:"#5c5c5c"}} className=''>
						{sale?.marca}
								</Typography>
							</abbr>
							{/* <small style={{fontFamily:"Montserrat",fontSize:isMobileScreen?"8px":"10px"}}>{sale?.marca}</small> */}
							{/* <p className='card-text'>{`${sale.descripcion.split(' ').slice(0, 6).join(' ')}...`}</p> */}
				</Link>

				<	Box sx={{display:"flex", flexDirection:"column", alignItems:"flex-start"}}>
								{/* <small style={{fontFamily:"Montserrat",fontSize:isMobileScreen?"8px":"10px"}}>{sale?.marca}</small> */}
					{sale.precioOferta > 0 ? (
						<abbr
							style={{ cursor: 'pointer', textDecoration: 'none' }}
							title={`precio en efectivo: ${currencyDisplay(sale?.precioEfectivo)}`}
						>
							<Typography className='oferta' style={{ display:"flex", flexDirection:"column",color:color ? color : "#D32F2F", textAlign:"left", fontWeight:600,fontSize: isMobileScreen ? "12px" : "16px" }}>
								<s style={{fontSize: isMobileScreen ? "8px" : "10px"}}>{currencyDisplay(sale.precioTarjeta)}</s> *{currencyDisplay(sale.precioOferta)}
							</Typography>
							<Typography style={{ textAlign:"left",color:"#5c5c5c",fontSize: isMobileScreen ? "10px" : "10px" }}>
								 *con Transferencia o efectivo en el local
								</Typography>
						</abbr>
					) : (
						<abbr
							style={{ cursor: 'pointer', textDecoration: 'none' }}
							title={`precio en efectivo: ${currencyDisplay(sale?.precioEfectivo)}`}
						>
							 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
  <Typography
    style={{
      color: "#474747",
      fontWeight: 600,
      fontSize: isMobileScreen ? "14px" : "16px",
      fontFamily: "Poppins",
    }}
  >
    {currencyDisplay(sale?.precioTarjeta)}
  </Typography>

  {/* Precio efectivo en su propia línea */}
  <Typography
    style={{
      textAlign: "left",
      color: "#23563F",
      fontSize: isMobileScreen ? "14px" : "16px",
      lineHeight: 1.1,
    }}
  >
    <b style={{ fontSize: isMobileScreen ? "14px" : "16px", color: "#23563F" }}>
     *{currencyDisplay(sale?.precioEfectivo)}
    </b>
  </Typography>

  {/* Leyenda debajo del precio */}
  <Typography
    style={{
      textAlign: "left",
      color: "#23563F",
      fontSize: isMobileScreen ? "10px" : "10px",
      marginTop: "2px",
    }}
  >
    *con Transferencia o efectivo en el local
  </Typography>
</Box>

						</abbr>
					)}
			<div style={{ width:"100%", display:"flex", justifyContent:"center"}} >

					<div  className='d-flex justify-content-between align-items-center'>
						

					<div >
  {sinStock ? (
    <Box
      sx={{
		width: isMobile ? "190px"  : "250px",
        height: isMobile?"38px":"45px",
        backgroundColor: "#ccc",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "not-allowed",
        color: "#777",
        fontFamily: "Poppins",
        fontSize: isMobile ? "12px" : "14px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        margin: "auto",
      }}
    >
      <Typography className="goBeautiGangas"
			sx={{
          color: color ? "white" : "#5C5C5C",
          fontFamily: "Poppins",
					fontWeight:400,
					fontSize: isMobile ? "12px" : "14px",
        }}
			>AGOTADO</Typography>
    </Box>
  ) : sale.variantes.length === 0 ? (
    <Box
      // onClick={() => manejadorAgregarACarrito()}
			onClick={() => navigate(urlCatalog)} 
      sx={{
        width: isMobile ? "190px"  : "250px",
        height: isMobile?"38px":"45px",
        backgroundColor: color ? color : "#23563F",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        marginTop: "10px",
        "&:hover": {
          backgroundColor: color ? darken(color, 0.2) : "#red",
          boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.2)",
        },
        "&:active": {
          transform: "scale(0.95)",
        },
      }}
    >
      <Typography
        className="goBeautiGangas"
        sx={{
          color: color ? "white" : "#ffff",
          fontFamily: "Poppins",
					fontWeight:400,
					fontSize: isMobile ? "12px" : "14px",
        }}
      >
        Comprar
      </Typography>
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        marginTop: "8px",
      }}
    >
      {!selectedVarianteId && !showVariantSelector ? (
        <Box
				onClick={() => navigate(urlCatalog)} 
          // onClick={() => setShowVariantSelector(true)}
          sx={{
			width: isMobile ? "190px" : "250px",
			height: isMobile?"38px":"45px",
            backgroundColor: color ? color : "#23563F",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
						marginTop: "10px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: color ? darken(color, 0.2) : "#red",
              boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.2)",
            },
            "&:active": {
              transform: "scale(0.95)",
            },
          }}
        >
          <Typography
            className="goBeautiGangas"
            sx={{
              color: color ? "white" : "#ffff",
              fontFamily: "Poppins",
							fontWeight:400,
              fontSize: isMobile ? "12px" : "14px",
            }}
          >
            Comprar
          </Typography>
        </Box>
      ) : null}

      {showVariantSelector && sale.variantes.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <select
            style={{
              fontFamily: "Montserrat",
              width: isMobile ? "100px" : "120px",
              fontSize: isMobile ? "10px" : "12px",
              height: isMobile ? "36px" : "40px",
              borderRadius: "6px",
              border: "1px solid #d9d9d9",
              paddingLeft: "6px",
              color: "#5c5c5c",
            }}
            value={selectedVarianteId}
            onChange={(e) => setSelectedVarianteId(e.target.value)}
          >
            <option value="">Variante</option>
            {sale.variantes
              .filter((variante) => variante.disponibles > 0)
              .map((variante) => (
                <option key={variante._id} value={variante._id}>
                  {variante.color}
                </option>
              ))}
          </select>

          <button
            className="btn btn-sm btn-outline-secondary carrito"
            onClick={() => manejadorAgregarACarrito()}
            style={{
              height: isMobile ? "36px" : "40px",
              fontSize: isMobile ? "10px" : "12px",
              fontFamily: "Poppins",
              padding: "0 10px",
              borderRadius: "6px",
            }}
          >
            Agregar
          </button>
        </Box>
      )}
    </Box>
  )}
</div>

						
					</div>
					</div>
				</Box>
				{sinStock && (
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(128, 128, 128, 0.151)",
      zIndex: 5,
      borderRadius: "8px",
      pointerEvents: "none", // permite que los eventos pasen al contenido debajo si fuera necesario
    }}
  />
)}
			</div>
			{showModal && (
				<ModalEditProduct
					show={showModal}
					handleClose={handleCloseModal}
					sale={sale?._id && sale}
					handleSave={handleSaveData}
				/>
			)}
		</div>
	);
}

export default Card;